import { render } from "./CIS-Home-Icon-Content.vue?vue&type=template&id=71dd7cbe&scoped=true"
import script from "./CIS-Home-Icon-Content.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Icon-Content.vue?vue&type=script&lang=js"

import "./CIS-Home-Icon-Content.vue?vue&type=style&index=0&id=71dd7cbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dd7cbe"]])

export default __exports__